import React, { useState } from 'react';
import { Container, Form, Row, Col, Button, Table, Spinner, Alert } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SideMenu from "../../../../Components/SideDrawer";
import PageHeader from "../../../../Components/Header";
import { employeeDetailsPayDetailsReport } from "../../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../../Utils/ErrorUtlis";
import { getCompanyShortForm } from "../../../../Utils/CommonUtils";
import { format } from 'date-fns';

function EmployeePayDetailsDateRange() {
  const [apiData, setApiData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    start_date: null,
    end_date: null,
  });

  const handleDateChange = (date, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: date,
    }));
  };

  const handleSearch = async () => {
    const formattedStartDate = formData.start_date ? format(formData.start_date, 'yyyy-MM-dd') : '';
    const formattedEndDate = formData.end_date ? format(formData.end_date, 'yyyy-MM-dd') : '';

    if (!formattedStartDate || !formattedEndDate) {
      setError('Please select both start and end dates.');
      return;
    }

    setIsLoading(true);
    setError(null);
    
    try {
      const response = await employeeDetailsPayDetailsReport(formattedStartDate, formattedEndDate);
      console.log('API Response:', response); 
      
      if (!response || !response.results) {
        setError(response?.message || 'No data received from server');
        setApiData([]);
        return;
      }

      const responseData = response.results;
      
      if (responseData.length === 0) {
        setError(response.message || 'No records found for the selected date range');
        setApiData([]);
        return;
      }

      const employeeDetailsPayReport = responseData.map((item) => ({
        emp_id: item.emp_id || 'N/A',
        Name: item.emp_name || 'N/A',
        Company: item.company ? getCompanyShortForm(item.company) : 'N/A',
        Design: item.Design || 'N/A',
        PayMonth: item.pay_month || 'N/A',
        WorkingDays: item.total_working_days || 0,
        OT:item.total_overtime_hours||0,
        OverTime: item.total_overtime_hours || 0,
        Basic_Pay: item.basic_pay || 0,
        OTPay: item.overtime_pay || 0,
        Incentives: item.incentives || 0,
        StdGross: item.standard_gross || 0,
        LOP: item.lop || 0,
        others: item.other || 0,
        NetPay:item.netpay||0
      }));

      setApiData(employeeDetailsPayReport);
    } catch (error) {
      console.error("Error fetching report:", error);
      setError(extractErrorMessage(error) || 'Failed to fetch data. Please try again.');
      setApiData([]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader title="Employee Pay details Date Wise" showButtons={true} style={{ height: '120px' }} />

        <Form>
          <Row className="align-items-end mb-3">
            <Col md={4}>
              <Form.Label>Start Date</Form.Label>
              <DatePicker
                selected={formData.start_date}
                onChange={(date) => handleDateChange(date, 'start_date')}
                dateFormat="dd/MM/yyyy"
                className="form-control"
                maxDate={formData.end_date}
                placeholderText="Select start date"
                isClearable
              />
            </Col>
            <Col md={4}>
              <Form.Label>End Date</Form.Label>
              <DatePicker
                selected={formData.end_date}
                onChange={(date) => handleDateChange(date, 'end_date')}
                dateFormat="dd/MM/yyyy"
                className="form-control"
                minDate={formData.start_date}
                placeholderText="Select end date"
                isClearable
              />
            </Col>
            <Col md={4}>
              <Button variant="primary" onClick={handleSearch} disabled={isLoading}>
                {isLoading ? 'Searching...' : 'Search'}
              </Button>
            </Col>
          </Row>
        </Form>

        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}

        {isLoading ? (
          <div className="text-center mt-4">
            <Spinner animation="border" variant="primary" />
            <p>Loading data...</p>
          </div>
        ) : (
          <>
            {apiData.length > 0 ? (
              <div className="table-responsive">
                <Table striped hover responsive="sm" size="sm">
                  <thead>
                    <tr>
                      <th className="fs-12">Emp ID</th>
                      <th className="fs-12">Name</th>
                      <th className="fs-12">Company</th>
                      <th className="fs-12">Design</th>
                      <th className="fs-12">Pay Month</th>
                      <th className="fs-12">Working Days</th>
                      <th className="fs-12">OT</th>
                      <th className="fs-12">Basic Pay</th>
                      <th className="fs-12">OT Pay</th>
                      <th className="fs-12">Incentives</th>
                      <th className="fs-12">Gross</th>
                      <th className="fs-12">LOP</th>
                      <th className="fs-12">Others</th>
                      <th className="fs-12">NetPay</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiData.map((emp, i) => (
                      <tr key={`${emp.emp_id}-${i}`}>
                        <td className="fs-12">{emp.emp_id}</td>
                        <td className="fs-12">{emp.Name}</td>
                        <td className="fs-12">{emp.Company}</td>
                        <td className="fs-12">{emp.Design}</td>
                        <td className="fs-12">{emp.PayMonth}</td>
                        <td className="fs-12">{emp.WorkingDays}</td>
                        <td className="fs-12">{emp.OT}</td>
                        <td className="fs-12">{emp.Basic_Pay}</td>
                        <td className="fs-12">{emp.OTPay}</td>
                        <td className="fs-12">{emp.Incentives}</td>
                        <td className="fs-12">{emp.StdGross}</td>
                        <td className="fs-12">{emp.LOP}</td>
                        <td className="fs-12">{emp.others}</td>
                        <td className="fs-12">{emp.NetPay}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            ) : (
              !error && <div className="text-center mt-4">No data available. Please select a date range and click Search.</div>
            )}
          </>
        )}
      </Container>
    </div>
  );
}

export default EmployeePayDetailsDateRange;